<template>
  <div style="font-size: 0;position: relative" class="big">
    <div style="display: none">
      <slot></slot>
    </div>

    <bg-yun :isbig="true">
      <img class="bigimg" :src="order.picPath" style="pointer-events: none;"  onerror="this.src='static/image/error.jpg'" width="100%">
      <div style="position: relative;background: #ffffff" class="bgyunc">
        <img src="./gou-01.svg" width="20" v-show="order.check>0" class="order_identifying" >
        <div class="flex-layout text-nowrap padding-10">
          <div class="flex-3 text-nowrap text-left color-black font-0-9-5">
            {{order.name}}
            <img height="18" :src="icon" v-for="icon in order.iconPath" style="vertical-align: middle">
          </div>
          <div class="flex-1-3 text-right color-blue text-nowrap">
            <img src="./vipIco.svg" alt="" width="18" v-if="order.memberprice < order.price" class="vip-img" >
            <span v-if="order.memberprice < order.price">
              <!--<span class="font-0-7">￥</span>-->
              <span class="font-1-1 ">{{order.memberprice}}<span class="font-0-6">元</span></span>
            </span>
          </div>
          <div class="flex-1 text-right color-yellow text-nowrap">
            <span v-if="order.price">
              <!--<span class="font-0-7">￥</span>-->
              <span class="font-1-1 ">{{order.price}}<span class="font-0-6">元</span></span>
            </span>
          </div>
        </div>
        <div class="order-desc font-0-8 color-gray text-left" v-if="order.desc.length>0">
          {{order.desc}}
        </div>
        <div style="position: absolute;bottom:20px;left:39%;" v-if="order.isSaleout">
          <img src="./soldout.svg" width="65" style="pointer-events: none;">
        </div>
        <div class="order-desc font-0-8 color-gray text-left" v-if="order.desc.length<=0">
          暂无菜品描述
        </div>
      </div>
    </bg-yun>
  </div>
</template>

<script>
  import bgyun from "../bg-yun/bgyun";

  export default {

    data () {
      return{
      }
    },
    components:{
      'bg-yun':bgyun
    },

    watch:{
      order(val,oldval){
        oldval =val
        this.order = val
      }
    },

    props: {
      order: {}, //定义传值的类型<br>
      type:{},
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .order-desc{padding: 0 10px;height: 45px;overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;margin-top: -5px;line-height: 22px;}
  .order_identifying{position: absolute;top: 0;right: 0;color: #fff;border-width: 10px;}
  .big{background: #FDFCF8}
  .bg-white{background:#ffffff}
  .flex-layout{ display: flex;  align-items: center;}
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .padding-10{padding: 10px;}
  .text-left{text-align: left;}
  .color-black{color:#000000}
  .color-gray{color:#9e9e9e}
  .font-0-8{font-size: 0.8em;}
  .font-0-6{font-size: 0.6em;}
  .font-1-1{font-size: 1.1em;}
  .text-right{text-align: right;}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .flex-3{flex:3;overflow:hidden;width: 0}
  .color-yellow{color:#FF6D00}
  .font-0-7{font-size: 0.7em;}
  .font-0-9-5{font-size: 0.95em;}
  .vip-img{vertical-align: middle;padding-bottom: 4px;pointer-events: none;}
  .flex-1-3{flex:1.3;overflow:hidden;width: 0}
  .color-blue{color:#00ABF8}
  .bigimg{overflow: hidden}
  .bgyunc{border-left: 1px solid #eeeeee;border-right: 1px solid #eeeeee;border-bottom: 1px solid #eeeeee;overflow: hidden;
  border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/bigPicModel/bigPicMode.vue